import homeConan from "../assets/homeImages/homeConan.jpg"

export default function Biography() {
    return (
    <div className="homeBiography card">
        <div className="homeBiographyText">
            <p>
                <img src={homeConan} />
                Welcome! I’m Tyler, a certified Salesforce Administrator and Platform App Builder with over five years of experience optimizing CRM systems across industries. I specialize in streamlining workflows, building scalable automations, and enabling cross-functional teams to work smarter. From complex integrations to intuitive dashboards, my focus is on creating Salesforce solutions that drive efficiency, clarity, and measurable results.
            </p>
            <p>
                I love to read, to cook, and I love my dog, Conan. At school I studied French literature. As a teaching assistant at the University of Utah, I took classes like medieval French literature, Mondernist English literature, and classical Latin while teaching French 1010 and 1020. I had the chance to learn and develop my reading talent, a skill that I regularly use as I develop new solutions and keep myself up-to-date on industry standards.    
            </p>
            <p>
                I also practice my reading skills in the kitchen, finding new dishes to prepare for my family. Most recently I have been using my electric smoker to  prepare some of my favorites, like pork tenderloin or smoked chicken. My favorite part about cooking is reading recipes and using that skill to find new meals to share with my loved ones.   
            </p>
        </div>
    </div>

    );
}